export const registerExpressionThemes = (monaco: typeof import('monaco-editor')) => {
  monaco.editor.defineTheme('expression-editor-theme', {
    base: 'vs',
    inherit: true,
    rules: [
      { token: 'property', foreground: '#C259BB' },
      { token: 'keyword', foreground: '#C259BB' },
      { token: 'string', foreground: '#3D9D7D' },
      { token: 'number', foreground: '#24585b' },
      { token: 'operator', foreground: '#d73a49' },
      { token: 'delimiter', foreground: '#C259BB' },
      { token: 'identifier', foreground: '#24292e' },
    ],
    colors: {
      'editor.background': '#f7f7f7',
      'editorSuggestWidget.background': '#ffffff',
      'editorSuggestWidget.border': '#e1e4e8',
      'editorSuggestWidget.foreground': '#24292e',
      'editorSuggestWidget.selectedBackground': '#f6f8fa',
      'editorSuggestWidget.selectedForeground': '#24292e',
      'editorSuggestWidget.highlightForeground': '#24292e',
      'editorSuggestWidget.focusHighlightForeground': '#24292e',
      'editorSuggestWidget.highlightBackground': '#f6f8fa',
      'editorSuggestWidget.focusHighlightBackground': '#f6f8fa',
    },
  });

  monaco.editor.defineTheme('expression-editor-theme-dark', {
    base: 'vs-dark',
    inherit: true,
    rules: [
      { token: 'property', foreground: '#d2a8ff' },
      { token: 'keyword', foreground: '#d2a8ff' },
      { token: 'string', foreground: '#a5d6ff' },
      { token: 'number', foreground: '#79c0ff' },
      { token: 'operator', foreground: '#ff7b72' },
      { token: 'delimiter', foreground: '#d2a8ff' },
      { token: 'identifier', foreground: '#e6edf3' },
    ],
    colors: {
      'editor.background': '#00000000',
      'editorSuggestWidget.background': '#161616',
      'editorSuggestWidget.border': '#30363d',
      'editorSuggestWidget.foreground': '#e6edf3',
      'editorSuggestWidget.selectedBackground': '#21262d',
      'editorSuggestWidget.selectedForeground': '#e6edf3',
      'editorSuggestWidget.highlightForeground': '#e6edf3',
      'editorSuggestWidget.focusHighlightForeground': '#e6edf3',
      'editorSuggestWidget.highlightBackground': '#21262d',
      'editorSuggestWidget.focusHighlightBackground': '#21262d',
    },
  });

  monaco.editor.defineTheme('expression-editor-theme-disabled', {
    base: 'vs',
    inherit: true,
    rules: [
      { token: 'property', foreground: '#C259BB' },
      { token: 'keyword', foreground: '#C259BB' },
      { token: 'string', foreground: '#3D9D7D' },
      { token: 'number', foreground: '#24585b' },
      { token: 'operator', foreground: '#d73a49' },
      { token: 'delimiter', foreground: '#C259BB' },
      { token: 'identifier', foreground: '#57606a' },
    ],
    colors: {
      'editor.background': '#00000000',
      'editor.foreground': '#57606a',
      'editorSuggestWidget.background': '#f7f7f7',
      'editorSuggestWidget.border': '#E5E7EB',
      'editorSuggestWidget.foreground': '#57606a',
      'editorSuggestWidget.selectedBackground': '#f7f7f7',
      'editorSuggestWidget.selectedForeground': '#57606a',
      'editorSuggestWidget.highlightForeground': '#57606a',
      'editorSuggestWidget.focusHighlightForeground': '#57606a',
      'editorSuggestWidget.highlightBackground': '#f7f7f7',
      'editorSuggestWidget.focusHighlightBackground': '#f7f7f7',
    },
  });
};
